import axios from 'axios'
import load from "@/LOAD.js";
import store from "@/store/index.js"
import storage from "./storage.js"
import router from "@/router/index.js"

const instance = axios.create({

    baseURL: load.getUrlApi(),
});

// ----------------------------------
// ------------ REQUEST -------------
// ----------------------------------
instance.interceptors.request.use(config => {

    if (store.getters['auth/isAuthenticated'])
        config.headers.Authorization = storage.getAuthHeader()

    return config

}, function (error) {

    console.log("request interceptor " + error)

    return Promise.reject(error)
})


// ----------------------------------
// ------------ RESPONSE ------------
// ----------------------------------
instance.interceptors.response.use(response => {

    return response

}, function (error) {

    let originalRequest = error.config

    // Controllo scadenza token
    if (error.response && error.response.status === 401 && !originalRequest._retry) {

        originalRequest._retry = true

        return store.dispatch("auth/refreshToken").then(authResponse => {

            instance.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.data.access_token;
            originalRequest.headers['Authorization'] = 'Bearer ' + authResponse.data.access_token

            return instance(originalRequest)

        })
            .catch(err => {
                console.log(err)

                store.commit("auth/DEL_TOKEN")
                router.push({ name: 'login' })
            });
    }

    console.log("response interceptor " + error)

    // Messaggio errore: mostra sempre quello restituito dal backend (pattern
    // `{ message: "..." }`) in uno snackbar globale. Il 401 è escluso: quel caso
    // è già gestito sopra (refresh token / redirect login).
    if (!error.response || error.response.status !== 401) {
        const messaggio = (error.response && error.response.data && error.response.data.message)
            || "Si è verificato un errore. Riprova."
        store.commit("app/SHOW_MESSAGE", { text: messaggio, color: "error" })
    }

    return Promise.reject(error);

})

export default instance
